import { PipeSerie, PipeSeriesVector } from "@imi-ernd-be/hyselect-engine";
import { isNotNil } from "@src/shared/helpers/guards";
import { toArray } from "../vector";
import { buildPipe, buildPipes, Pipe } from "./buildPipes";

export type PipeSeries = {
  custom: boolean;
  default: boolean;
  defaultPipe: Pipe;
  editable: boolean;
  id: string;
  name: string | null;
  pipes: Pipe[];
};

export function buildPipeSerie(series: PipeSerie | null): PipeSeries | null {
  if (!series) return null;
  const pipesList = buildPipes(series.getPipesList());
  if (pipesList.length === 0) return null;
  const defaultPipe = series.getDefaultPipe();
  return {
    custom: false,
    default: series.default,
    defaultPipe: defaultPipe ? buildPipe(defaultPipe) : pipesList[0],
    editable: series.editable,
    id: series.id || "all",
    name: series.name,
    pipes: pipesList,
  };
}

export function buildPipeSeries(pipeSeries: PipeSeriesVector): PipeSeries[] {
  return toArray(pipeSeries).map(buildPipeSerie).filter(isNotNil);
}
